import { Injectable } from '@angular/core';
import { RegistroAvaliacao } from '../../../core/config/services/avaliacao.service';

/**
 * Serviço responsável por validações e regras de negócio relacionadas a notas
 * Separação de responsabilidades do NotaService
 */
@Injectable({
  providedIn: 'root'
})
export class NotaValidationService {
  /** Baseado em isItemEditavel do AngularJS: false p/ CALCULO_MEDIA, NOTA_PARA_EXAME, CALCULO_INSTRUMENTOS e MEDIA_FINAL numérico/conceito numérico. */
  isNotaEditavel(registro: RegistroAvaliacao): boolean {
    return this.isNotaEditavelBase(registro, false);
  }

  /** Baseado em isItemEditavelAnunal do AngularJS: igual a isNotaEditavel, mas CALCULO_INSTRUMENTOS é editável na visão anual. */
  isNotaEditavelAnual(registro: RegistroAvaliacao): boolean {
    return this.isNotaEditavelBase(registro, true);
  }

  private isNotaEditavelBase(registro: RegistroAvaliacao, permiteCalculoInstrumentos: boolean): boolean {
    const tipoPeriodo = registro.avaliavel?.tipoPeriodo;
    const modoAvaliacao = registro.avaliavel?.modoAvaliacao;

    const tiposNaoEditaveis = ['CALCULO_MEDIA', 'NOTA_PARA_EXAME'];
    if (tiposNaoEditaveis.includes(tipoPeriodo)) {
      return false;
    }

    // CALCULO_INSTRUMENTOS só é editável na visualização anual
    if (tipoPeriodo === 'CALCULO_INSTRUMENTOS' && !permiteCalculoInstrumentos) {
      return false;
    }

    if (tipoPeriodo === 'MEDIA_FINAL' &&
        (modoAvaliacao === 'NUMERICO' || modoAvaliacao === 'CONCEITO_NUMERICO')) {
      return false;
    }
    
    return true;
  }

  // TODO: implementar verificação de data (atual > data fim enturmação); sempre retorna false por ora.
  isSemNota(registro: RegistroAvaliacao): boolean {
    return false;
  }

  permiteParecer(registro: RegistroAvaliacao): boolean {
    return registro.avaliavel.tipoPeriodo === 'EXAME_FINAL' ||
           registro.avaliavel.tipoPeriodo === 'MEDIA_PERIODO';
  }

  permiteParecerAnual(registro: RegistroAvaliacao): boolean {
    return registro.avaliavel.tipoPeriodo === 'MEDIA_PERIODO' ||
           registro.avaliavel.tipoPeriodo === 'EXAME_FINAL' ||
           registro.avaliavel.tipoPeriodo === 'MEDIA_FINAL' ||
           registro.avaliavel.tipoPeriodo === 'CONSELHO_CLASSE';
  }

  permiteCha(registro: RegistroAvaliacao): boolean {
    return registro.avaliavel.tipoPeriodo === 'CHA_OBJETIVO_MEDIA_PERIODO' ||
           registro.avaliavel.tipoPeriodo === 'CHA_OBJETIVO_EXAME_FINAL';
  }
}

